import { Injectable } from '@angular/core';
import { BehaviorSubject, Observable } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class NotificationService {
  private errorArray = [];

  private error$: BehaviorSubject<any> = new BehaviorSubject<any>([]);

  constructor() { }

  /***** Error Notification *****/
  getErrors(): Observable<any> {
    return this.error$.asObservable();
  }

  showError(errorObjs: any) {
    this.errorArray = this.errorArray.concat(errorObjs);
    this.error$.next(this.errorArray);
  }

  resetErrors() {
    this.errorArray = [];
  }
}

